export default {
  preferredStores: [],
  closeStores: [],
  groceriesList: [],
}
